import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { CreateDelivery } from 'app/dtos/Deliveries/createDelivery';
import { UpdateDelivery } from 'app/dtos/Deliveries/updateDelivery';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DeliveryService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllDeliveries(page, size, search, startDate, endDate, companyId, certificateCompanyId, deviceAcceptanceStatesId) {
    const queryParams = new URLSearchParams();

    queryParams.append("Page", page.toString());
    queryParams.append("Size", size.toString());
    queryParams.append("search", search.toString());

    if (startDate !== null && startDate !== undefined) queryParams.append("StartDate", startDate);
    if (endDate !== null && endDate !== undefined) queryParams.append("EndDate", endDate);
    if (companyId !== null && companyId !== undefined) queryParams.append("CompanyId", companyId.toString());
    if (certificateCompanyId !== null && certificateCompanyId !== undefined) queryParams.append("CertificateCompanyId", certificateCompanyId.toString());
    if (deviceAcceptanceStatesId !== null && deviceAcceptanceStatesId !== undefined) queryParams.append("DeviceAcceptanceStatesId", deviceAcceptanceStatesId);
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Delivery,
      queryString: queryParams.toString()
    });
    return await firstValueFrom(observable);
  }

  async createDeliveries(createDelivery: CreateDelivery) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Delivery
    }, createDelivery);
    return await firstValueFrom(observable);
  }

  async getByIdDelivery(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Delivery,
    }, id);
    return await firstValueFrom(observable);
  }

  async updateDelivery(updateDelivery: UpdateDelivery) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Delivery
    }, updateDelivery);
    return await firstValueFrom(observable);
  }

  async sendDeliveryMail(mail, deliveryMethod, offerNo, devices: { brand: string, model: string, serino: string }[], companyName, deliveryDate, certificateCompanyName?: string, deliveryPerson?: string) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Delivery,
      action: "SendDeliveryMail"
    },
      {
        mail: mail,
        offerNo: offerNo,
        deliveryMethod: deliveryMethod,
        devices: devices,
        companyName: companyName,
        deliveryDate: deliveryDate,
        certificateCompanyName: certificateCompanyName,
        deliveryPerson: deliveryPerson
      }
    );
    return await firstValueFrom(observable);
  }

  async getDeliveryCount() {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Delivery,
      action: "GetDeliveriesCount"
    });
    return await firstValueFrom(observable);
  }

  async deleteDelivery(id: number, token?: string) {
    const options: any = {
      controller: ControllerType.Delivery
    };

    if (token) {
      options.headers = new HttpHeaders({
        token: token
      });
    }

    const observable: Observable<any> = this.httpClientService.delete(options, id);
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}